import { ISO2_TO_ISO3 } from '@/constants/ISO2_TO_ISO3'

/**
 * Converts a country code from ISO2 to ISO3.
 * Remove spaces and convert to uppercase before conversion.
 * @param countryCode Country code (ex: 'br', ' Us ')
 * @returns ISO3 code or null if not found
 */
export const getCountryISO3 = (countryCode?: string): string | null => {
  if (!countryCode) return null

  const normalizedCode = countryCode.replace(/\s+/g, '').toUpperCase()

  return ISO2_TO_ISO3[normalizedCode] || null
}
